import {ValueObject} from '@s-ui/domain'

export class BreadcrumbUrlBuilderRequestValueObject extends ValueObject {
  /**
   * @constructor
   * @param {Object} data
   * @param {Array<makeId: Number, make: String, modelId: Number, model: String>} data.items
   */
}
